import type { ApiGroupJSON } from '@/mastodon/api_types/groups';
import { createAppSelector } from '@/mastodon/store/typed_functions';

const isDefined = (group: ApiGroupJSON | undefined): group is ApiGroupJSON =>
  !!group;

export const selectGroup = createAppSelector(
  [(state) => state.groups.groups, (_state, id: string) => id],
  (groups, id) => groups[id],
);

export const selectGroupCategories = createAppSelector(
  [(state) => state.groups.categories],
  (categories) => categories,
);

export const selectGroupsByCategory = createAppSelector(
  [
    (state) => state.groups.groups,
    (state, categoryId: string) => state.groups.byCategoryId[categoryId],
  ],
  (groups, query) => (query?.ids ?? []).map((id) => groups[id]).filter(isDefined),
);

export const selectMyGroups = createAppSelector(
  [(state) => state.groups.groups, (state) => state.groups.myGroups],
  (groups, query) => query.ids.map((id) => groups[id]).filter(isDefined),
);

export const selectAdministeredGroups = createAppSelector(
  [(state) => state.groups.groups, (state) => state.groups.administeredGroups],
  (groups, query) => query.ids.map((id) => groups[id]).filter(isDefined),
);

export const selectSuggestedGroups = createAppSelector(
  [(state) => state.groups.groups, (state) => state.groups.suggestedGroups],
  (groups, query) => query.ids.map((id) => groups[id]).filter(isDefined),
);
